// Autogenerated file
export const shippingOrderStatusesEnum = {
    Received: "Received",
    DistributionBidCreated: "DistributionBidCreated",
    FailedToCreateDistributionBid: "FailedToCreateDistributionBid",
    FailedToGenerateResponseTitle: "FailedToGenerateResponseTitle",
    ResponseTitleGenerated: "ResponseTitleGenerated",
    FailedToSendResponseTitle: "FailedToSendResponseTitle",
    ResponseTitleSent: "ResponseTitleSent",
    Completed: "Completed",
    ManuallyDistributionBidCreated: "ManuallyDistributionBidCreated",
    ManuallyDistributionBidAttached: "ManuallyDistributionBidAttached",
    ManuallyDistributionBidDetached: "ManuallyDistributionBidDetached",
};
export const shippingOrderStatuses = [
    { label: "Получен", value: "Received" },
    { label: "Заказ создан", value: "DistributionBidCreated" },
    { label: "Ошибка создания заказа по ЭЗЗ", value: "FailedToCreateDistributionBid" },
    { label: "Ошибка формирования ответного титула", value: "FailedToGenerateResponseTitle" },
    { label: "Ответный титул сформирован", value: "ResponseTitleGenerated" },
    { label: "Ошибка отправки ответного титула", value: "FailedToSendResponseTitle" },
    { label: "Ответный титул отправлен", value: "ResponseTitleSent" },
    { label: "Документооборот завершён", value: "Completed" },
    { label: "Заказ создан вручную", value: "ManuallyDistributionBidCreated" },
    { label: "Заказ привязан вручную", value: "ManuallyDistributionBidAttached" },
    { label: "Заказ отвязан вручную", value: "ManuallyDistributionBidDetached" },
];
